import React from "react";
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@material-ui/core";
import moment from 'moment';

const TableAssistance = ({ language, data, data_total, title }) => {

    return (
        <div style={{
            height: "100vh",
            paddingLeft: "12px",
            paddingRight: "12px",
        }}>
            <Typography variant="h5" component="h2" style={{ textAlign: 'center' }}>
                {title}
            </Typography>
            <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                    <caption style={{ fontWeight: 900, color: 'black' }}>{language === "en" ? "TOTAL HOURS" : "TOTAL HORAS"} <span style={{ float: 'right' }}>{data_total}</span></caption>
                    <TableHead>
                        <TableRow>
                            <TableCell>{language === "en" ? "DATE" : "FECHA"}</TableCell>
                            <TableCell align="center">{language === "en" ? "IN" : "ENTRADA"}</TableCell>
                            <TableCell align="center">{language === "en" ? "OUT" : "SALIDA"}</TableCell>
                            <TableCell align="center">{language === "en" ? "HOURS" : "HORAS"}</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {Object.keys(data).map((item) => {
                            return (
                                <>
                                    {data[item].map((f) => {
                                        return (
                                            <TableRow key={`${item}-${f.in}`}>
                                                <TableCell>{moment(item).format('MM/DD/YYYY')}</TableCell>
                                                <TableCell align="center">{f.in}</TableCell>
                                                <TableCell align="center">{f.out}</TableCell>
                                                <TableCell align="center">{f.hours}</TableCell>
                                            </TableRow>
                                        )
                                    })}
                                </>
                            )
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
        </div>

    )

}

export default TableAssistance;